import { BOOKINGAPI } from '../../../helpers/api'

export function getUser() {
  return BOOKINGAPI.get('/login/user')
}
